// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './components'               //加载公共组件
import './assets/css/animate.css'
import './assets/css/style1.0.min.css'

import { Radio,Carousel,CarouselItem,Cascader,Drawer } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Radio);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(Drawer);

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // if(to.path != '/' && !sessionStorage.getItem("myInfo")){
  //   console.log(1)
  // }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  window.scrollTo(0,0)
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js